module.exports = __webpack_public_path__ + "static/media/temp-persona-6.a3f9360a.jpg";